import { Image } from "react-bootstrap";
import { Link } from "react-router-dom";

import ico_00 from '../../assets/img/ico_00.svg';
import ico_01 from '../../assets/img/ico_01.svg';
import ico_02 from '../../assets/img/ico_02.svg';
import ico_03 from '../../assets/img/ico_03.svg';
import ico_04 from '../../assets/img/ico_04.svg';

function Home() {

    return (
        <div id="wrap-body">
            <div class="heading-group slideshow color-w">
                <h1><span><span class="large">O</span>ptima<span class="large">S</span>olutions&trade;</span></h1>
                <h3>WEB-BASED DINING SERVICES MANAGEMENT SYSTEM</h3>
                <div class="star-group">
                    <i class="fa fa-star-o"></i>
                    <i class="fa fa-star-o star-1x"></i>
                    <i class="fa fa-star-o"></i>
                </div>
            </div>
            <div class="container" id="main-content">
                <div class="row intro_text">
                    <div class="col-sm-12 col-md-8">
                        <div class="mod-welcome">
                            <div class="title">Who
                                <h3>we are</h3>
                            </div>
                            <p>OptimaSolutions&trade; is a senior care dining operations firm that provides an innovative web-based software. This system interfaces with other applications in the community to offer clients an integrated solution for quality dining operations. The software improves efficiency and assists clients with every aspect of their operations.</p>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-4">
                        <Link id="lnk_menu_management" to="../Menu">
                            <Image src={ico_00}></Image>
                            <span>Menu</span> Management System
                        </Link>
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-12 col-sm-5 col-md-4">
                        <div class="mn-category color-w">
                            <div class="mn-category-inner">
                                <div class="title">
                                    <h3>WEB-BASED SOFTWARE</h3>
                                </div>
                                <ul class="list-ul">
                                    <li>To assist in controlling food cost.</li>
                                    <li>To develop community specific menus.</li>
                                    <li>To assist in operating the food service department efficiently.</li>
                                    <li>To manage weight loss or gain through the supplement usage manager.</li>
                                </ul>
                                <Link id="lnk_read_more" to="../Menu">Read more
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-7 col-md-8">
                        <div class="gallery-1">
                            <div class="row">
                                <div class="gallery-item col-xs-7 col-sm-6 col-md-6">
                                    <Link  to="../Menu" class="hover-img n1">
                                        <span class="bg_img bg_01"></span>
                                        <div class="hover-caption color-w">
                                            <h3>Extensive <br /> recipe files</h3>
                                        </div>
                                    </Link>
                                </div>
                                <div class="gallery-item col-xs-5 col-sm-6 col-md-6">
                                    <Link  to="../Menu" class="hover-img n2">
                                        <span class="bg_img bg_02"></span>
                                        <div class="hover-caption color-w">
                                            <h3>Menu <br /> production sheets</h3>
                                        </div>
                                    </Link>
                                </div>
                                <div class="gallery-item col-xs-5 col-sm-6 col-md-6">
                                    <Link  to="../Menu" class="hover-img n2">
                                        <span class="bg_img bg_03"></span>
                                        <div class="hover-caption color-w">
                                            <h3>Suggested <br /> order guide</h3>
                                        </div>
                                    </Link>
                                </div>
                                <div class="gallery-item col-xs-12 col-sm-12 col-md-12">
                                    <Link  to="../Menu" class="hover-img n2">
                                        <span class="bg_img bg_04"></span>
                                        <div class="hover-caption color-w">
                                            <h3>Nutritional <br /> analysis</h3>
                                        </div>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="product most-popular">
                    <div class="title">System
                        <h3>Applications</h3>
                    </div>
                    <div id="wrapper_featured" class="clearfix">
                        <Link class="box" to="../Menu">
                            <Image src={ico_01}></Image>
                            <div class="box_label"><p>Menu System</p></div>
                        </Link>
                        <Link class="box" to="../Management">
                            <Image src={ico_02}></Image>
                            <div class="box_label"><p>Management System</p></div>
                        </Link>
                        <Link class="box" to="../Ticket">
                            <Image src={ico_03}></Image>
                            <div class="box_label"><p>Tray Ticket System</p></div>
                        </Link>
                        <Link class="box" to="../Reporting">
                            <Image src={ico_04}></Image>
                            <div class="box_label"><p>Clinical System</p></div>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );


}

export default Home;